import "./styles/v4-entry.css";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { initAnalytics } from "./analytics/analytics";
import { initSmoothScroll } from "./motion/smooth-scroll";
import { initScrollScenes } from "./motion/scroll-scenes";
import { initV4Motion } from "./motion/v4-home";
import { applyMotionPreference, isMotionRuntimeEnabled, observeReducedMotion, prefersReducedMotion } from "./motion/reduced-motion";
import { initSiteChrome } from "./ui/site-chrome";
import { initHeroVideo } from "./motion/hero-video";

let controllers: Array<{ destroy(): void }> = [];
let generation = 0;
let analytics = initAnalytics();

function destroyMotion(): void {
  generation++;
  controllers.reverse().forEach(controller => controller.destroy());
  controllers = [];
}

function boot(reduced = prefersReducedMotion()): void {
  destroyMotion();
  const sequence = generation;
  applyMotionPreference(reduced);
  const disabled = reduced || !isMotionRuntimeEnabled();
  const smooth = initSmoothScroll({ enabled: !disabled, reducedMotion: reduced });
  const chrome = initSiteChrome(smooth);
  controllers = [smooth, chrome, initScrollScenes({ lenis: smooth.lenis, reducedMotion: disabled }), initV4Motion(disabled), initHeroVideo({ enabled: !disabled, reducedMotion: reduced })];
  void document.fonts.ready.then(() => {
    if (sequence !== generation) return;
    ScrollTrigger.refresh(); chrome.syncCurrentHash();
  });
}

boot();
const stopPreference = observeReducedMotion(boot);
window.addEventListener("pagehide", () => { destroyMotion(); analytics.destroy(); });
window.addEventListener("pageshow", event => { if (event.persisted) { analytics = initAnalytics(); boot(); } });
if (import.meta.hot) import.meta.hot.dispose(() => { destroyMotion(); analytics.destroy(); stopPreference(); });
